import { Link } from "react-router-dom"
import styled from "styled-components"
import { useTranslate } from "~/ur-react-hooks"
import { Button, OutlineButton } from "../../../components/Button"
import Toast from "../../../modules/toasts/Toast"

const Layout = styled.div`
  display: flex;
  justify-content: center;
`

const Card = styled.div`
  margin-top: 2rem;
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 392px;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Title = styled.h4`
  font-size: 18px;
  margin: 0;
  color: ${(props) => props.theme.colors.gray0};
`

export type SetupSuccessfullProps = {}

const ChangePaymentMethodSuccess: React.FC<SetupSuccessfullProps> = () => {
  const translations = useTranslate({
    title: "change-payment-method-success.title",
    toast: "change-payment-method-success.toast",
    createWorksheet: "common.create-worksheet",
    home: "common.home",
  })

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Toast type="success" message={translations.toast} />
        <Link to="/generator/mathematics">
          <OutlineButton leftIcon="plus" width="100%">
            {translations.createWorksheet}
          </OutlineButton>
        </Link>
        <Link to="/home">
          <Button width="100%">{translations.home}</Button>
        </Link>
      </Card>
    </Layout>
  )
}

export default ChangePaymentMethodSuccess
